var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQedC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 72",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0.878534 0L0.878534 0.878674L0 0.878674L0 0Z",
    transform: "translate(0.3427975 0.1494788)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0.878674 0L0.878674 0.878485L0 0.878485L0 0Z",
    transform: "translate(0.2951188 0.1753559)",
    id: "path_2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Q-EDC-Logo-Main-White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-557"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439339C0.878677 0.681994 0.682468 0.878677 0.439339 0.878677C0.197157 0.878677 0 0.681994 0 0.439339C0 0.196683 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196683 0.878677 0.439339",
    transform: "translate(73.22398 70.50995)",
    id: "Fill-1",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439339C0.878677 0.681994 0.681994 0.878677 0.439339 0.878677C0.197631 0.878677 0 0.681994 0 0.439339C0 0.196683 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439339",
    transform: "translate(75.7908 63.66521)",
    id: "Fill-3",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(56.7145 65.94697)",
    id: "Fill-5",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439339C0.878677 0.681994 0.681994 0.878677 0.439339 0.878677C0.197157 0.878677 0 0.681994 0 0.439339C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439339",
    transform: "translate(61.65796 62.49289)",
    id: "Fill-7",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.682468 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(68.47076 58.43668)",
    id: "Fill-9",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439337C0.878685 0.681991 0.682 0.878674 0.438869 0.878674C0.196685 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196685 0 0.438869 0C0.682 0 0.878685 0.196683 0.878685 0.439337",
    transform: "translate(71.1963 57.50038)",
    id: "Fill-11",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.682468 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(68.47076 55.34569)",
    id: "Fill-13",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(90.99882 57.96853)",
    id: "Fill-15",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(98.57819 51.00948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0.878534 0L0.878534 0.878674L0 0.878674L0 0Z",
    transform: "translate(0.3427975 0.1494788)",
    id: "Clip-18",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.878676 0.439337C0.878676 0.681991 0.681993 0.878674 0.439338 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439338 0C0.681993 0 0.878676 0.196683 0.878676 0.439337",
    transform: "translate(0.3427975 0.1494788)",
    id: "Fill-17",
    fill: "#EA0A8C",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(95.45118 37.23649)",
    id: "Fill-20",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(82.78407 48.61132)",
    id: "Fill-22",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(79.8419 50.15995)",
    id: "Fill-24",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(76.25919 53.17966)",
    id: "Fill-26",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(73.22166 53.17966)",
    id: "Fill-28",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(73.99597 50.8954)",
    id: "Fill-30",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197631 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(75.7908 50.42725)",
    id: "Fill-32",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(74.93227 49.34678)",
    id: "Fill-34",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(77.01544 47.91431)",
    id: "Fill-36",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(75.32289 47.91431)",
    id: "Fill-38",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(74.93227 45.97858)",
    id: "Fill-40",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(72.5635 46.91507)",
    id: "Fill-42",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(73.22166 48.61132)",
    id: "Fill-44",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(71.66426 50.42725)",
    id: "Fill-46",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(67.7626 51.36355)",
    id: "Fill-48",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.196682 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196682 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(69.58247 53.48928)",
    id: "Fill-50",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(66.33018 53.17966)",
    id: "Fill-52",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(64.08455 54.42583)",
    id: "Fill-54",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(60.01123 53.48928)",
    id: "Fill-56",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.45734 51.83194)",
    id: "Fill-58",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(55.66711 50.27426)",
    id: "Fill-60",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(53.25071 50.52488)",
    id: "Fill-62",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.438863 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(52.14085 52.30005)",
    id: "Fill-64",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(50.45801 52.15683)",
    id: "Fill-66",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(48.38133 53.23635)",
    id: "Fill-68",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(47.68294 51.2108)",
    id: "Fill-70",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(43.78038 50.99303)",
    id: "Fill-72",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(49.98967 50.27426)",
    id: "Fill-74",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(47.44502 47.33834)",
    id: "Fill-76",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(50.5418 48.12606)",
    id: "Fill-78",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(62.59426 51.36355)",
    id: "Fill-80",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(60.11024 50.27426)",
    id: "Fill-82",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(68.231 45.00711)",
    id: "Fill-84",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439337C0.878685 0.681991 0.682 0.878674 0.438869 0.878674C0.196685 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196685 0 0.438869 0C0.682 0 0.878685 0.196683 0.878685 0.439337",
    transform: "translate(71.1963 45.06749)",
    id: "Fill-86",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(64.55293 49.9591)",
    id: "Fill-88",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.196682 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196682 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(69.58247 47.91431)",
    id: "Fill-90",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.438863 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.65128 56.28199)",
    id: "Fill-92",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(53.36042 56.56407)",
    id: "Fill-94",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439339C0.878674 0.681994 0.681991 0.878677 0.439337 0.878677C0.197157 0.878677 0 0.681994 0 0.439339C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439339",
    transform: "translate(48.94692 62.96104)",
    id: "Fill-96",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(41.07237 63.89734)",
    id: "Fill-98",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.196682 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196682 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(37.45403 58.64933)",
    id: "Fill-100",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(35.27502 54.89398)",
    id: "Fill-102",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(42.23962 45.30374)",
    id: "Fill-104",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(50.07388 45.87976)",
    id: "Fill-106",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(46.13478 43.09261)",
    id: "Fill-108",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(40.3055 41.41602)",
    id: "Fill-110",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(43.6045 41.14967)",
    id: "Fill-112",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.438863 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(42.57379 38.6664)",
    id: "Fill-114",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.438863 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(45.89597 38.4373)",
    id: "Fill-116",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(49.81379 38.09365)",
    id: "Fill-118",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(50.17754 43.5073)",
    id: "Fill-120",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(53.81673 44.36749)",
    id: "Fill-122",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.19763 0.87867 0 0.681988 0 0.439335C0 0.196682 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(53.92043 46.141)",
    id: "Fill-124",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(53.97782 48.12606)",
    id: "Fill-126",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(56.91493 46.55986)",
    id: "Fill-128",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(58.83934 48.12606)",
    id: "Fill-130",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(58.78194 45.06749)",
    id: "Fill-132",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.04081 44.13118)",
    id: "Fill-134",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(51.8627 41.94317)",
    id: "Fill-136",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(47.78474 41.41602)",
    id: "Fill-138",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.19763 0.87867 0 0.681988 0 0.439335C0 0.196682 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(51.27863 40.21336)",
    id: "Fill-140",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.19763 0.87867 0 0.681988 0 0.439335C0 0.196682 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(51.8627 37.23346)",
    id: "Fill-142",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(53.92043 37.70161)",
    id: "Fill-144",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.19763 0.87867 0 0.681988 0 0.439335C0 0.196682 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(53.97782 39.60265)",
    id: "Fill-146",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(55.66711 38.19825)",
    id: "Fill-148",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.04081 38.29981)",
    id: "Fill-150",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(57.38284 39.60265)",
    id: "Fill-152",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(58.78194 38.90545)",
    id: "Fill-154",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197631 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(60.29725 40.21336)",
    id: "Fill-156",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(61.91805 40.87914)",
    id: "Fill-158",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.438865 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(63.85867 40.21336)",
    id: "Fill-160",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.197156 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197156 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(65.34759 40.68151)",
    id: "Fill-162",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439335C0.87867 0.681988 0.681988 0.87867 0.439335 0.87867C0.197156 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197156 0 0.439335 0C0.681988 0 0.87867 0.196682 0.87867 0.439335",
    transform: "translate(66.66526 42.05772)",
    id: "Fill-164",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(62.07772 39.01232)",
    id: "Fill-166",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(60.87716 38.76796)",
    id: "Fill-168",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(59.8446 37.59654)",
    id: "Fill-170",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(58.4399 37.36327)",
    id: "Fill-172",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.77715 36.34829)",
    id: "Fill-174",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(62.16938 37.72455)",
    id: "Fill-176",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(63.10569 36.81644)",
    id: "Fill-178",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.438865 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(63.85867 35.41204)",
    id: "Fill-180",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(64.32658 36.52464)",
    id: "Fill-182",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439335C0.878685 0.681988 0.682 0.87867 0.439342 0.87867C0.197159 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197159 0 0.439342 0C0.682 0 0.878685 0.196682 0.878685 0.439335",
    transform: "translate(64.87919 37.59654)",
    id: "Fill-184",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(63.67862 38.29981)",
    id: "Fill-186",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(65.91408 38.24128)",
    id: "Fill-188",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(67.70014 38.60227)",
    id: "Fill-190",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197631 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(68.35413 40.56744)",
    id: "Fill-192",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(69.10573 42.68531)",
    id: "Fill-194",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(71.00887 42.24611)",
    id: "Fill-196",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(73.66085 43.44967)",
    id: "Fill-198",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(73.24801 37.97308)",
    id: "Fill-200",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(76.24667 39.19398)",
    id: "Fill-202",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(74.91792 41.94133)",
    id: "Fill-204",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(77.86288 42.08502)",
    id: "Fill-206",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.197156 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197156 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(77.91654 37.64976)",
    id: "Fill-208",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(77.28806 35.67469)",
    id: "Fill-210",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(75.38488 35.62076)",
    id: "Fill-212",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439335C0.878685 0.681988 0.682 0.87867 0.439342 0.87867C0.197633 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197633 0 0.439342 0C0.682 0 0.878685 0.196682 0.878685 0.439335",
    transform: "translate(79.56838 34.79483)",
    id: "Fill-214",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.682468 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(79.99928 36.62626)",
    id: "Fill-216",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.438865 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(81.66962 36.78801)",
    id: "Fill-218",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.438865 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(82.81881 35.02834)",
    id: "Fill-220",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(85.61981 36.1236)",
    id: "Fill-222",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(84.50626 38.99659)",
    id: "Fill-224",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(80.86151 42.06697)",
    id: "Fill-226",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(79.49664 42.22877)",
    id: "Fill-228",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(72.08266 39.689)",
    id: "Fill-230",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(70.45256 39.689)",
    id: "Fill-232",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(69.98417 37.72455)",
    id: "Fill-234",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(68.13938 36.59223)",
    id: "Fill-236",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439337C0.878685 0.681991 0.682 0.878674 0.439342 0.878674C0.197159 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197159 0 0.439342 0C0.682 0 0.878685 0.196683 0.878685 0.439337",
    transform: "translate(66.35331 35.71379)",
    id: "Fill-238",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(64.95744 34.74948)",
    id: "Fill-240",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.438865 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(67.6418 34.3591)",
    id: "Fill-242",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197631 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(69.23256 34.92512)",
    id: "Fill-244",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(64.19607 33.54891)",
    id: "Fill-246",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.196683 0.878672 0 0.681989 0 0.439336C0 0.196682 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(58.56441 31.21626)",
    id: "Fill-248",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.682465 0.878672 0.439337 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439337 0C0.682465 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(57.21716 31.509)",
    id: "Fill-250",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.42218 33.10966)",
    id: "Fill-252",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.438863 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(56.89872 34.42758)",
    id: "Fill-254",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(56.459 35.93919)",
    id: "Fill-256",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(54.74934 35.8545)",
    id: "Fill-258",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(55.86659 33.24763)",
    id: "Fill-260",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.438863 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(54.25877 33.14602)",
    id: "Fill-262",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.438863 0.878672C0.196683 0.878672 0 0.681989 0 0.439336C0 0.196682 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(55.37602 31.48701)",
    id: "Fill-264",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(53.86905 30.99621)",
    id: "Fill-266",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(50.94076 32.33355)",
    id: "Fill-268",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(49.68787 30.86081)",
    id: "Fill-270",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(52.56573 33.17981)",
    id: "Fill-272",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(52.8027 34.68654)",
    id: "Fill-274",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(49.34957 35.82071)",
    id: "Fill-276",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(47.58895 33.77246)",
    id: "Fill-278",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(45.54052 31.48701)",
    id: "Fill-280",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(44.03398 27.89829)",
    id: "Fill-282",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439335C0.878674 0.681988 0.681991 0.87867 0.439337 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439335",
    transform: "translate(44.20341 34.90664)",
    id: "Fill-284",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.438863 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(40.58085 33.63687)",
    id: "Fill-286",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.438865 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(38.66801 25.96853)",
    id: "Fill-288",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(35.99332 33.87384)",
    id: "Fill-290",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878681 0.439337C0.878681 0.681991 0.681997 0.878674 0.439341 0.878674C0.197158 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197158 0 0.439341 0C0.681997 0 0.878681 0.196683 0.878681 0.439337",
    transform: "translate(26.5355 41.71616)",
    id: "Fill-292",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(24.50322 31.22668)",
    id: "Fill-294",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(22.47095 28.27062)",
    id: "Fill-296",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(60.60735 30.72801)",
    id: "Fill-298",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(62.46189 30.72801)",
    id: "Fill-300",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(63.41853 29.32261)",
    id: "Fill-302",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.197156 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197156 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(64.90189 29.17611)",
    id: "Fill-304",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(66.5417 29.84952)",
    id: "Fill-306",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(69.81156 30.16194)",
    id: "Fill-308",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439339C0.878677 0.681994 0.681994 0.878677 0.438865 0.878677C0.196683 0.878677 0 0.681994 0 0.439339C0 0.196683 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196683 0.878677 0.439339",
    transform: "translate(68.42583 28.8246)",
    id: "Fill-310",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.03526 30.0546)",
    id: "Fill-312",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(58.92867 29.9472)",
    id: "Fill-314",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(60.36341 29.26384)",
    id: "Fill-316",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(61.78848 28.67834)",
    id: "Fill-318",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(63.03763 27.67289)",
    id: "Fill-320",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.196683 0.878672 0 0.681989 0 0.439336C0 0.196682 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(60.10981 27.66318)",
    id: "Fill-322",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439339C0.878677 0.681994 0.681994 0.878677 0.439339 0.878677C0.196683 0.878677 0 0.681994 0 0.439339C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439339",
    transform: "translate(61.64222 25.79891)",
    id: "Fill-324",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.682468 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(64.57977 26.53085)",
    id: "Fill-326",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(67.25446 26.84327)",
    id: "Fill-328",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439339C0.87867 0.681994 0.681988 0.878677 0.439335 0.878677C0.19763 0.878677 0 0.681994 0 0.439339C0 0.196683 0.19763 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439339",
    transform: "translate(69.15759 26.95061)",
    id: "Fill-330",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(71.11948 27.01891)",
    id: "Fill-332",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(71.74431 26.22839)",
    id: "Fill-334",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.197156 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197156 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(73.39384 29.1273)",
    id: "Fill-336",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.438865 0.878672C0.196683 0.878672 0 0.681989 0 0.439336C0 0.196682 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(72.36914 30.47412)",
    id: "Fill-338",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(76.3707 29.17611)",
    id: "Fill-340",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197631 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(84.96307 29.02526)",
    id: "Fill-342",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439337C0.878685 0.681991 0.682 0.878674 0.439342 0.878674C0.196685 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196685 0 0.439342 0C0.682 0 0.878685 0.196683 0.878685 0.439337",
    transform: "translate(80.94805 23.28322)",
    id: "Fill-344",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(77.27507 23.83142)",
    id: "Fill-346",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(75.58948 23.68076)",
    id: "Fill-348",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(68.40872 24.84545)",
    id: "Fill-350",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681991 0.681988 0.878674 0.439335 0.878674C0.197156 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197156 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(66.05157 25.35275)",
    id: "Fill-352",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197631 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(63.83138 24.92787)",
    id: "Fill-354",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439339C0.878685 0.681994 0.682 0.878677 0.439342 0.878677C0.197159 0.878677 0 0.681994 0 0.439339C0 0.196683 0.197159 0 0.439342 0C0.682 0 0.878685 0.196683 0.878685 0.439339",
    transform: "translate(66.61341 23.26957)",
    id: "Fill-356",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.197631 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(71.0672 22.94071)",
    id: "Fill-358",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439336C0.878685 0.681989 0.682 0.878672 0.439342 0.878672C0.197159 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197159 0 0.439342 0C0.682 0 0.878685 0.196682 0.878685 0.439336",
    transform: "translate(72.69402 18.08313)",
    id: "Fill-360",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(70.91398 20.0036)",
    id: "Fill-362",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(68.71279 20.42502)",
    id: "Fill-364",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(65.87891 20.91701)",
    id: "Fill-366",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(62.78772 21.50246)",
    id: "Fill-368",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(60.77393 21.08085)",
    id: "Fill-370",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.682465 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.682465 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.4481 20.21445)",
    id: "Fill-372",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(54.91919 18.83265)",
    id: "Fill-374",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(52.15569 18.99649)",
    id: "Fill-376",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(46.46479 18.83265)",
    id: "Fill-378",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(43.84194 23.21194)",
    id: "Fill-380",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.438863 0.878672C0.196683 0.878672 0 0.681989 0 0.439336C0 0.196682 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(40.82109 17.80218)",
    id: "Fill-382",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(31.09061 17.98687)",
    id: "Fill-384",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(33.8208 11.89028)",
    id: "Fill-386",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.19763 0.878672 0 0.681989 0 0.439336C0 0.196682 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(49.69668 11.45569)",
    id: "Fill-388",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.43934C0.878674 0.681997 0.681991 0.878681 0.439337 0.878681C0.197157 0.878681 0 0.681997 0 0.43934C0 0.196684 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196684 0.878674 0.43934",
    transform: "translate(35.9054 4.560048)",
    id: "Fill-390",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-394",
    transform: "translate(58.29384 0.2985782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0.878674 0L0.878674 0.878485L0 0.878485L0 0Z",
    transform: "translate(0.2951188 0.1753559)",
    id: "Clip-393",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(0.2951188 0.1751663)",
    id: "Fill-392",
    fill: "#EA0A8C",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(49.3454 15.83493)",
    id: "Fill-395",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439339C0.878674 0.681994 0.681991 0.878677 0.439337 0.878677C0.197157 0.878677 0 0.681994 0 0.439339C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439339",
    transform: "translate(54.14631 15.53066)",
    id: "Fill-397",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.19763 0.878672 0 0.681989 0 0.439336C0 0.196682 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(55.55142 12.97791)",
    id: "Fill-399",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(58.59587 16.39706)",
    id: "Fill-401",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.682468 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(62.60028 18.13009)",
    id: "Fill-403",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.197631 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(62.34293 13.72725)",
    id: "Fill-405",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.68199 0.681994 0.878673 0.439339 0.878673C0.197157 0.878673 0 0.68199 0 0.439336C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(65.43412 13.00128)",
    id: "Fill-407",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439336C0.878685 0.68199 0.682 0.878673 0.439342 0.878673C0.197159 0.878673 0 0.68199 0 0.439336C0 0.196682 0.197159 0 0.439342 0C0.682 0 0.878685 0.196682 0.878685 0.439336",
    transform: "translate(65.50449 8.153649)",
    id: "Fill-409",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87867 0.439337C0.87867 0.681992 0.681988 0.878675 0.439335 0.878675C0.19763 0.878675 0 0.681992 0 0.439337C0 0.196683 0.19763 0 0.439335 0C0.681988 0 0.87867 0.196683 0.87867 0.439337",
    transform: "translate(73.25915 4.067393)",
    id: "Fill-411",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(77.3917 1.002559)",
    id: "Fill-413",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.68199 0.681994 0.878672 0.439339 0.878672C0.196683 0.878672 0 0.68199 0 0.439336C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(80.68886 5.437109)",
    id: "Fill-415",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(66.83929 17.07626)",
    id: "Fill-417",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(75.08265 21.87716)",
    id: "Fill-419",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439339C0.878677 0.681994 0.681994 0.878677 0.439339 0.878677C0.197157 0.878677 0 0.681994 0 0.439339C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439339",
    transform: "translate(70.18829 15.53066)",
    id: "Fill-421",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(77.07327 13.02469)",
    id: "Fill-423",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(72.82133 22.73521)",
    id: "Fill-425",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.682468 0.878672 0.439339 0.878672C0.197631 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197631 0 0.439339 0C0.682468 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(81.30399 30.93047)",
    id: "Fill-427",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(79.16621 32.8628)",
    id: "Fill-429",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(76.60351 32.27384)",
    id: "Fill-431",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(74.06863 32.25995)",
    id: "Fill-433",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(81.94407 26.23578)",
    id: "Fill-435",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(93.53644 22.68014)",
    id: "Fill-437",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(98.50118 31.90725)",
    id: "Fill-439",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.682468 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(80.09369 18.69497)",
    id: "Fill-441",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.682468 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(78.33725 21.99701)",
    id: "Fill-443",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197631 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(73.46834 24.63905)",
    id: "Fill-445",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.196683 0.878672 0 0.681989 0 0.439336C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(76.78081 25.07436)",
    id: "Fill-447",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.196683 0.878672 0 0.681989 0 0.439336C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(80.02749 26.06801)",
    id: "Fill-449",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439338C0.878677 0.681992 0.681994 0.878675 0.439339 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439338",
    transform: "translate(74.2038 26.79213)",
    id: "Fill-451",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.438865 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.438865 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(76.09763 26.28465)",
    id: "Fill-453",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439339C0.878677 0.681994 0.681994 0.878677 0.439339 0.878677C0.197631 0.878677 0 0.681994 0 0.439339C0 0.196683 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439339",
    transform: "translate(77.73374 29.13886)",
    id: "Fill-455",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.682465 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.682465 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(58.44038 28.48303)",
    id: "Fill-457",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.438863 0.878672C0.196683 0.878672 0 0.681989 0 0.439336C0 0.196682 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(56.03971 28.93199)",
    id: "Fill-459",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(54.38512 27.28019)",
    id: "Fill-461",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(52.87768 27.71867)",
    id: "Fill-463",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(51.82241 29.91133)",
    id: "Fill-465",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.196683 0.878675 0 0.681992 0 0.439338C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(49.8082 27.97905)",
    id: "Fill-467",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(50.68526 25.25185)",
    id: "Fill-469",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439339C0.878674 0.681994 0.681991 0.878677 0.438863 0.878677C0.196683 0.878677 0 0.681994 0 0.439339C0 0.196683 0.196683 0 0.438863 0C0.681991 0 0.878674 0.196683 0.878674 0.439339",
    transform: "translate(53.60431 25.10118)",
    id: "Fill-471",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(56.07071 23.82678)",
    id: "Fill-473",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(57.94839 24.34749)",
    id: "Fill-475",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(59.52431 24.86815)",
    id: "Fill-477",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(61.5936 23.44289)",
    id: "Fill-479",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.682465 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.682465 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(58.97588 22.63431)",
    id: "Fill-481",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(54.98815 22.1)",
    id: "Fill-483",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439336C0.878674 0.681989 0.681991 0.878672 0.439337 0.878672C0.19763 0.878672 0 0.681989 0 0.439336C0 0.196682 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196682 0.878674 0.439336",
    transform: "translate(51.30175 22.37398)",
    id: "Fill-485",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(49.25976 21.52445)",
    id: "Fill-487",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(46.84796 26.5128)",
    id: "Fill-489",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439338C0.878674 0.681992 0.681991 0.878675 0.439337 0.878675C0.197157 0.878675 0 0.681992 0 0.439338C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439338",
    transform: "translate(56.84967 27.23365)",
    id: "Fill-491",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(57.86464 25.75976)",
    id: "Fill-493",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(55.75645 25.80862)",
    id: "Fill-495",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(54.38512 29.00673)",
    id: "Fill-497",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(65.39663 32.67048)",
    id: "Fill-499",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439337C0.878685 0.681991 0.682 0.878674 0.439342 0.878674C0.197159 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197159 0 0.439342 0C0.682 0 0.878685 0.196683 0.878685 0.439337",
    transform: "translate(66.35331 33.3536)",
    id: "Fill-501",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439336C0.878677 0.681989 0.681994 0.878672 0.439339 0.878672C0.197157 0.878672 0 0.681989 0 0.439336C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439336",
    transform: "translate(63.10569 31.73346)",
    id: "Fill-503",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.682468 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.682468 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(64.55711 31.60668)",
    id: "Fill-505",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(66.67545 31.4699)",
    id: "Fill-507",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(69.18398 32.67048)",
    id: "Fill-509",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878685 0.439337C0.878685 0.681991 0.682 0.878674 0.439342 0.878674C0.196685 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196685 0 0.439342 0C0.682 0 0.878685 0.196683 0.878685 0.439337",
    transform: "translate(71.81928 33.54891)",
    id: "Fill-511",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(72.69772 35.93919)",
    id: "Fill-513",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(55.81521 40.68151)",
    id: "Fill-515",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(54.03938 42.06768)",
    id: "Fill-517",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(56.85753 41.81569)",
    id: "Fill-519",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(58.90829 43.19464)",
    id: "Fill-521",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(61.78336 44.36749)",
    id: "Fill-523",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(61.23355 46.141)",
    id: "Fill-525",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(61.78336 48.07701)",
    id: "Fill-527",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(64.32658 48.07701)",
    id: "Fill-529",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.196683 0.87867 0 0.681988 0 0.439335C0 0.196682 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(66.42322 46.92019)",
    id: "Fill-531",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197157 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(66.07933 45.00711)",
    id: "Fill-533",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439335C0.878677 0.681988 0.681994 0.87867 0.439339 0.87867C0.197157 0.87867 0 0.681988 0 0.439335C0 0.196682 0.197157 0 0.439339 0C0.681994 0 0.878677 0.196682 0.878677 0.439335",
    transform: "translate(63.91422 45.87976)",
    id: "Fill-535",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.197631 0.878674 0 0.681991 0 0.439337C0 0.196683 0.197631 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(64.65891 42.94706)",
    id: "Fill-537",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(63.05521 42.57076)",
    id: "Fill-539",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878677 0.439337C0.878677 0.681991 0.681994 0.878674 0.439339 0.878674C0.196683 0.878674 0 0.681991 0 0.439337C0 0.196683 0.196683 0 0.439339 0C0.681994 0 0.878677 0.196683 0.878677 0.439337",
    transform: "translate(60.98175 42.68531)",
    id: "Fill-541",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878674 0.439337C0.878674 0.681991 0.681991 0.878674 0.439337 0.878674C0.19763 0.878674 0 0.681991 0 0.439337C0 0.196683 0.19763 0 0.439337 0C0.681991 0 0.878674 0.196683 0.878674 0.439337",
    transform: "translate(58.71346 41.00663)",
    id: "Fill-543",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91991 2.45971C4.91991 3.81848 3.81896 4.9199 2.46019 4.9199C1.10142 4.9199 0 3.81848 0 2.45971C0 1.10095 1.10142 0 2.46019 0C3.81896 0 4.91991 1.10095 4.91991 2.45971",
    transform: "translate(58.75061 32.20749)",
    id: "Fill-545",
    fill: "#EA0A8C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68057 0C1.2 0 0 1.2 0 2.68057C0 4.16114 1.2 5.36161 2.68057 5.36161C4.16067 5.36161 5.36114 4.16114 5.36114 2.68057C5.36114 1.2 4.16067 0 2.68057 0",
    transform: "translate(58.56569 32.10687)",
    id: "Fill-547",
    fill: "#2C4652",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65308 12.4076L13.1322 12.4076L13.1322 7.82701L5.65308 7.82701L5.65308 4.92844L14.4081 4.92844L14.4081 0L0 0L0 20.5825L14.6687 20.5825L14.6687 15.6545L5.65308 15.6545L5.65308 12.4076Z",
    transform: "translate(22.60317 24.49626)",
    id: "Fill-549",
    fill: "#2C4652",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4076 0.811848C13.7019 1.35308 14.7853 2.08768 15.654 3.01517C16.5237 3.94265 17.1806 5.02986 17.6265 6.2763C18.0697 7.52275 18.2924 8.85213 18.2924 10.2626C18.2924 11.828 18.0455 13.2441 17.5531 14.5095C17.0602 15.7754 16.3597 16.8573 15.4517 17.7564C14.5431 18.655 13.4512 19.3502 12.1763 19.8431C10.9 20.336 9.47915 20.5825 7.91375 20.5825L0 20.5825L0 0L7.91375 0C9.61469 0 11.1123 0.27109 12.4076 0.811848ZM11.3493 14.118C11.745 13.6351 12.045 13.0649 12.2479 12.4076C12.4517 11.7507 12.5531 11.0355 12.5531 10.2626C12.5531 9.47014 12.446 8.74502 12.2337 8.08815C12.0209 7.43128 11.7161 6.87062 11.3204 6.40663C10.9242 5.94313 10.436 5.58057 9.8564 5.31943C9.2763 5.05877 8.62891 4.92844 7.91374 4.92844L5.65308 4.92844L5.65308 15.6545L7.91374 15.6545C8.64834 15.6545 9.30569 15.5194 9.88626 15.2483C10.4649 14.9777 10.9536 14.6014 11.3493 14.118Z",
    transform: "translate(39.01062 24.49626)",
    id: "Fill-551",
    fill: "#2C4652",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4934C0 4.6981 4.6981 0 10.4938 0C16.2896 0 20.9877 4.6981 20.9877 10.4934C20.9877 12.4754 20.428 14.3223 19.473 15.9028C20.3663 16.3379 20.9877 17.246 20.9877 18.3062C20.9877 19.7867 19.7867 20.9872 18.3062 20.9872C17.246 20.9872 16.3384 20.3664 15.9033 19.473C14.3223 20.4275 12.4758 20.9872 10.4938 20.9872C4.6981 20.9872 0 16.2891 0 10.4934ZM5.36161 10.4934C5.36161 13.328 7.65971 15.6256 10.4938 15.6256C13.328 15.6256 15.6256 13.328 15.6256 10.4934C15.6256 7.65924 13.328 5.36161 10.4938 5.36161C7.65971 5.36161 5.36161 7.65924 5.36161 10.4934Z",
    transform: "translate(9.478672E-05 24.09175)",
    id: "Fill-553",
    fill: "#2C4652",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4938 15.6256C7.66019 15.6256 5.36161 13.328 5.36161 10.4934C5.36161 7.65924 7.66019 5.36161 10.4938 5.36161C12.3569 5.36161 13.9815 6.35687 14.8815 7.84123L19.4654 5.07014C17.6256 2.03507 14.3014 0 10.4938 0C4.69811 0 0 4.6981 0 10.4934C0 16.2891 4.69811 20.9872 10.4938 20.9872C14.3014 20.9872 17.6256 18.9521 19.4654 15.9171L14.8815 13.146C13.9815 14.6303 12.3569 15.6256 10.4938 15.6256",
    transform: "translate(65.26479 24.09175)",
    id: "Fill-555",
    fill: "#2C4652",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQedC);
export default __webpack_public_path__ + "static/media/qed-c.33f1509b23217639aab9355764c9958d.svg";
export { ForwardRef as ReactComponent };